import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <section className="section">
      <div className="container narrow-container">
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p>The requested page does not exist.</p>
        <Link className="button button-primary" to="/">
          Return home
        </Link>
      </div>
    </section>
  )
}
